import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

export interface InputChanged<TValue extends object> {
  term: string;
  items: TValue[];
}

@Component({
  selector: 'app-selection-list-base',
  templateUrl: './selection-list-base.component.html',
  styleUrls: ['./selection-list-base.component.scss']
})
export abstract class SelectionListBaseComponent<TValue extends object> implements OnInit {

  @Input() hideLabel = false;
  @Input() labelText: string;
  @Input() selectObjectText: string;
  @Input() selectedObjectId: number | string;
  @Input() selectedObject: object;
  @Output() selectedObjectChangedEvent: EventEmitter<TValue> = new EventEmitter<TValue>();
  @Output() searchChangedEvent: EventEmitter<InputChanged<TValue>> = new EventEmitter<InputChanged<TValue>>();

  selectionListSubject$ = new BehaviorSubject<TValue[]>([]);
  selectionList$: Observable<TValue[]> = this.selectionListSubject$.asObservable();
  selectionListLoading = false;
  selectionListInput$ = new Subject<string>();

  constructor() {
  }

  ngOnInit(): void {
    this.loadSelectionList();
  }

  protected abstract loadSelectionList(): void;

  selectedObjectChanged(selectedObject: TValue): void {
    this.selectedObjectChangedEvent.emit(selectedObject);
  }

  searchChanged(event: any): void {
    this.searchChangedEvent.emit(event);
  }

  returnTrue(term: string, item): boolean {
    return true;
  }
}
